import { render, staticRenderFns } from "./ConvenioCreate.vue?vue&type=template&id=01121f4c&scoped=true"
import script from "./ConvenioCreate.vue?vue&type=script&lang=js"
export * from "./ConvenioCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01121f4c",
  null
  
)

export default component.exports